import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-club-injuries',
  templateUrl: './club-injuries.component.html',
  styleUrls: ['./club-injuries.component.css']
})
export class ClubInjuriesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/club-injuries/club-injuries.component.ts